<main role="main" >
    <section>
        <article>
            <app-laboFR-header></app-laboFR-header>
            <app-labo-content></app-labo-content>
        </article>
    </section>
</main>